import { FC } from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

const EshopIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <G fill={color} clipPath="url(#eshop-icon-clip)">
                <Path d="M13.645 5.275h-7.19l-.304-1.07A.27.27 0 0 0 5.89 4H4.353a.265.265 0 0 0-.267.267c0 .15.118.267.267.267h1.325l1.673 6.792a.27.27 0 0 0 .261.205h4.596c.137 0 .262-.062.311-.205l.063-.261a.214.214 0 0 0-.2-.299H7.769l-.249-1.045h5.168c.125 0 .23-.08.261-.205l.958-3.906a.28.28 0 0 0-.05-.23.26.26 0 0 0-.211-.106m-7.034.77h1.263l.136 1.332H6.94zm.777 3.135-.317-1.262h.995l.13 1.262zm2.233 0h-.883l-.13-1.262H9.62zm0-1.803h-1.07l-.136-1.331H9.62zm1.443 1.803h-.908V7.918h1.051l-.15 1.262zm.205-1.803h-1.113V6.046h1.269zm1.207 1.803h-.87l.148-1.262h1.039l-.311 1.262zm.448-1.803H11.81l.156-1.331h1.287zM8.202 11.873a.59.59 0 0 0-.716.716c.05.205.218.373.423.422a.59.59 0 0 0 .716-.715.58.58 0 0 0-.423-.423M11.917 11.873a.59.59 0 0 0-.716.716c.05.205.218.373.423.422a.59.59 0 0 0 .715-.715.58.58 0 0 0-.423-.423" />
                <Path d="M18.602 14.896H17.36V6.524a.52.52 0 0 0-.523-.522h-1.741a.155.155 0 0 0-.15.106l-.124.354a.164.164 0 0 0 .15.218h1.71v7.544H3.303V6.68h1.455c.13 0 .218-.124.174-.249l-.105-.305a.19.19 0 0 0-.174-.124H3.147a.52.52 0 0 0-.522.522v8.372H1.394a.183.183 0 0 0-.187.186v.305c0 .336.274.603.603.603h16.37a.604.604 0 0 0 .603-.603v-.305a.183.183 0 0 0-.187-.186zm-7.177.074a.466.466 0 0 1-.466.467H9.012a.466.466 0 0 1-.466-.467v-.074h2.873v.074z" />
            </G>
            <Defs>
                <ClipPath id="eshop-icon-clip">
                    <Path fill="#fff" d="M0 0h20v20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default EshopIcon
